import Signup from "../components/auth/signup/SignUp";
export const SignupPage = () => {
  return (
  <Signup/>
  );
};
